module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-report-1.b19ef735.svg";